import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ModalService, HomeService,RoleService,NewsService } from '../_services';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
declare var jquery: any;
declare var $: any;
declare var alertify: any;
declare var moment: any;
@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {

  @ViewChild('downloadZipLink', { static: false }) private downloadZipLink: ElementRef;
  sel_usr_type = '';
  media_domain = `${environment.media_domain}`;
  dob: any;
  previousRoute: string;
  creditForm: FormGroup;
  creditUser: any = [];
  currentIndex = null;
  loading = false;
  previousUrl = '';
  submitted = false;
  users$: any;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: DataTables.Settings = {};
  user_details: any;
  curPage = 1;
  perPage = 10;
  last_page: any;

  total: any;
  from:any;
  to:any;
  searchUser: any;
  apiUrl="";
  news$ : any;
  limit:any;
  pageCounter:any;
  topage:any;
  page:any;
  history:any;

  constructor(
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private home: HomeService,
    private role: RoleService,
    private newSer: NewsService
  ) {
  }
  get f() { return this.creditForm.controls; }


  

  ngOnInit() {

    const that = this;


  this.apiUrl = `${environment.apiUrl}`;
    this.dtOptions = {
      pagingType: 'full_numbers',
      processing: true,
      pageLength: 10,
      language: {
        searchPlaceholder: "Name/Email/Mobile No."
      },
      columnDefs: [{
        searchable: false,
        orderable: false,
        targets: 0
      }]
      //order: [[ 1, 'asc' ]]
    };


    this.home.getLogin('','').subscribe(data => {
  
      this.history = data.data.result.docs;
      this.curPage = data.data.result.page;
      this.total= data.data.result.totalDocs;
      this.from = data.data.result.prevPage;
      this.to = data.data.result.nextPage;
      this.last_page = data.data.result.totalPages;
      this.limit = data.data.result.limit;
      this.page = data.data.result.page;
      this.pageCounter = data.data.result.pagingCounter;
      this.topage = (this.limit * (this.page - 1)) + this.history.length;
      this.dtTrigger.next();
    }, error => {
      console.error(error);
    });


    this.creditForm = this.formBuilder.group({
      comments: ['', [Validators.required, Validators.maxLength(500)]],
      credits: ['', [Validators.required, Validators.min(1), Validators.max(100000)]],
      type: '1'
    });


  }

  search(e){
    
      if (e.target.value) {
        this.searchUser = true;
      } else {
        this.searchUser = false;
      }

    this.home.getLogin(e.target.value,1).subscribe(data =>{
       
      this.history = data.data.result.docs;
      this.curPage = data.data.result.page;
      this.total= data.data.result.totalDocs;
      this.from = data.data.result.prevPage;
      this.to = data.data.result.nextPage;
      this.last_page = data.data.result.totalPages;
      this.limit = data.data.result.limit;
      this.page = data.data.result.page;
      this.pageCounter = data.data.result.pagingCounter;
      this.topage = (this.limit * (this.page - 1)) + this.history.length;
      this.dtTrigger.next();
    })
 
  }

  pageChange(e){

    this.home.getLogin('',e).subscribe(data =>{
      this.history = data.data.result.docs;
      this.curPage = data.data.result.page;
      this.total= data.data.result.totalDocs;
      this.from = data.data.result.prevPage;
      this.to = data.data.result.nextPage;
      this.last_page = data.data.result.totalPages;
      this.limit = data.data.result.limit;
      this.page = data.data.result.page;
      this.pageCounter = data.data.result.pagingCounter;
      this.topage = (this.limit * (this.page - 1)) + this.history.length;
      this.dtTrigger.next();
    }, error => {
      this.loading = false;
    });
  }

  view(e,i){
   
      e.stopPropagation();
      $('.temple_drp_menu').css('display','none');
      $('.temple_drp_menu' + i).toggle();
      $(document).click(function(e){
       if(!$(e.target).closest('.temple_drp_btn, .temple_drp_menu').length){
       $('.temple_drp_menu').hide();
       }
     })
  }
    
 
  editNews(e,user){
    this.router.navigate(['/create-news'], { queryParams: {id: user._id}})
  }

  add(e){
    this.router.navigate(['/create-news'])
  }

  deleteNews(e,user){
    var that = this;
    alertify.confirm(that.home.getTranslate('news.are_you_sure_you_want_to_delete_this_news?'), function () {
      that.newSer.delete(user._id)
        .subscribe(
          data => {
            if (data.status.code == 0) {
              that.toastr.success(that.home.getTranslate('faq.deleted_successfully'))
            
              that.newSer.getNews('',that.curPage).subscribe(data => {
  
                that.news$ = data.data.news.docs;
                var i =0;
                that.news$.forEach(data=>{
               var descrpt = data.description;
               that.news$[i++].description = $('<span />').html(descrpt.replace(/<[^>]+>/g, '')).text();
                })
                that.curPage = data.data.news.page;
                that.total= data.data.news.totalDocs;
                that.from = data.data.news.prevPage;
                that.to = data.data.news.nextPage;
                that.last_page = data.data.news.totalPages;
                that.limit = data.data.news.limit;
                that.page = data.data.news.page;
                that.pageCounter = data.data.news.pagingCounter;
                that.topage = (that.limit * (that.page - 1)) + that.news$.length;
                that.dtTrigger.next();
              }, error => {
                console.error(error);
              });
          
           
            } else {
              that.toastr.error(data.status.message)
            
            }
          },
          error => {
            that.toastr.error(error)
           
          });
    }
      , function () {
        // that.toastr.error('Delete action cancelled')
      }).set('labels', { cancel: that.home.getTranslate('faq.cancel'), ok: that.home.getTranslate('faq.ok') });

  }

  
  
}
